import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import ContactIcon from '@mui/icons-material/ContactPageOutlined';
import AssignmentIcon from '@mui/icons-material/AssignmentOutlined';
import InicioIcon from '@mui/icons-material/WebAssetOutlined';
import PromocionesIcon from '@mui/icons-material/SellOutlined';
import ServiceIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import VisionIcon from '@mui/icons-material/CenterFocusWeak';
import ImplementIcon from '@mui/icons-material/ImportExportOutlined';
import { useNavigate } from 'react-router-dom';

const SidebarWeb = () => {
    const navigate = useNavigate();

    const handleDashboardInicio = () => {
      navigate('/dashboard/inicio');
    };

    const handleDashboardServicio = () => {
      navigate('/dashboard/servicio');
    };

    const handleDashboardVision = () => {
      navigate('/dashboard/vision');
    };

    const handleDashboardPrograma = () => {
      navigate('/dashboard/programa');
    };

    const handleDashboardBlog = () => {
      navigate('/dashboard/blog');
    };

    const handleDashboardContactanos = () => {
        navigate('/dashboard/contactanos');
    };

    const handleDashboardCertificaciones = () => {
      navigate('/dashboard/certificados');
    };

    return(
        <React.Fragment>
        <ListSubheader component="div" inset>
        Página web
        </ListSubheader>

        <ListItemButton onClick={handleDashboardInicio}>
          <ListItemIcon>
            <InicioIcon />
          </ListItemIcon>
          <ListItemText primary="Inicio"/>
        </ListItemButton>

        <ListItemButton onClick={handleDashboardServicio}>
          <ListItemIcon>
            <ServiceIcon />
          </ListItemIcon>
          <ListItemText primary="Servicios" />
        </ListItemButton>

        <ListItemButton onClick={handleDashboardVision}>
          <ListItemIcon>
            <VisionIcon />
          </ListItemIcon>
          <ListItemText primary="Visión" />
        </ListItemButton>

        <ListItemButton onClick={handleDashboardPrograma}>
          <ListItemIcon>
            <ImplementIcon />
          </ListItemIcon>
          <ListItemText primary="Implementaciones" />
        </ListItemButton>

        <ListItemButton onClick={handleDashboardBlog}>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Blog"/>
        </ListItemButton>

        <ListItemButton onClick={handleDashboardContactanos}>
          <ListItemIcon>
            <ContactIcon />
          </ListItemIcon>
          <ListItemText primary="Contáctanos" />
        </ListItemButton>

        <ListItemButton onClick={handleDashboardCertificaciones}>
          <ListItemIcon>
            <PromocionesIcon />
          </ListItemIcon>
          <ListItemText primary="Certificados" />
        </ListItemButton>
      </React.Fragment>
    );
};

export default SidebarWeb;